<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">
          {{ $t(pageTitle) }}
        </h1>
        <div class="search inner">
          <div class="title accordion d-flex justify-content-between align-items-center" id="accordionDrawing-header" data-toggle="collapse" data-target=".accordionDrawing" aria-controls="searchContent searchButton">
            <h2 class="title">{{ $t('検索条件') }}</h2>
            <div class="accordion-toggle-btn">
              <b-button block id="accordionDrawing-up">{{ $t('閉じる') }}</b-button>
              <b-button block id="accordionDrawing-down">{{ $t('開く') }}</b-button>
            </div>
          </div>
          <div id="searchContent" class="accordionDrawing content collapse" aria-labelledby="accordionDrawing-header">
            <div class="d-flex flex-row flex-wrap">
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('工場') }}:&nbsp;</label
                >
                <select name="" id=""></select>
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('部署') }}:&nbsp;</label
                >
                <select name="" id=""></select>
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('置き場') }}:&nbsp;</label
                >
                <select name="" id=""></select>
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('区分') }}:&nbsp;</label
                >
                <select name="" id=""></select>
              </div>
            </div>
            <div class="d-flex flex-row flex-wrap">
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('品番') }}:&nbsp;</label
                >
                <input v-model="search.code" type="text" class="input -small form-control">
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('品名') }}:&nbsp;</label
                >
                <input v-model="search.name" type="text" class="input -small form-control">
              </div>
            </div>
          </div>
          <div id="searchButton" class="button accordionDrawing collapse">
            <button class="btn btn-info" @click="searchMet()">
              {{ $t('検索') }}
            </button>
          </div>
        </div>
        <div class="inner d-flex justify-content-between mt-4 mb-4">
          <div class="d-flex">
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="locationCreate()"
            >
                {{ $t('構成部品データ取込') }}
            </button>
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="captureModalOpen()"
            >
                {{ $t('製品置場データ取込') }}
            </button>
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="inventoryKindListModalOpen()"
            >
                {{ $t('在庫区分情報登録') }}
            </button>
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="spaceListModalOpen()"
            >
                {{ $t('置き場情報登録') }}
            </button>
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="captureModalOpen()"
            >
                {{ $t('製品/材料登録') }}
            </button>
          </div>
          <select
            class="input input-sm display-number form-control custom-select"
            v-model="mixinParPage"
            @change="mixinCurrentPageClear()"
          >
            <option value="10">{{ $t('10行') }}</option>
            <option value="30">{{ $t('30行') }}</option>
            <option value="50">{{ $t('50行') }}</option>
            <option value="100">{{ $t('100行') }}</option>
          </select>
        </div>
        <div class="table-list inner">
          <h2 class="title">{{ $t('検索結果') }}</h2>
          <div class="content">
            <table class="table table-bordered table-hover">
              <thead class="thead">
                <tr>
                  <th scope="col" id="code" @click="mixinSearchWordSort('code')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('品番') }}</th>
                  <th scope="col" id="name" @click="mixinSearchWordSort('name')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('品名') }}</th>
                  <th scope="col">{{ $t('詳細') }}</th>
                  <th scope="col">{{ $t('構成部品') }}</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <template v-if="!load && mixinGetItems.length">
                  <tr v-for="(item, index) in mixinGetItems" :key="index">
                    <td>{{ item.code }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn-light btn"
                        @click="detailLink(item)"
                      >
                        {{ $t('詳細') }}
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn-light btn"
                        @click="detailLink(item)"
                      >
                        {{ $t('構成部品') }}
                      </button>
                    </td>

                  </tr>
                </template>
                <template v-else-if="!load && !mixinGetItems.length">
                  <tr>
                    <td rowspan="2" colspan="99" class="text-center">
                      {{ $t('ノーデータメッセージ') }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="load">
                  <tr>
                    <td colspan="12">
                      <div
                        class="d-flex justify-content-center m-5"
                        v-if="load"
                      >
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class=" inner d-flex justify-content-between">
          <paginate
            :page-count="mixinGetPageCount"
            :force-page="mixinGetForcePage"
            :page-range="3"
            :margin-pages="1"
            :click-handler="mixinClickCallback"
            :prev-text="'«'"
            :next-text="'»'"
            :container-class="'pagination justify-content-end mt-3 mr-0'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            ref="page"
          >
          </paginate>
        </div>
        <!-- <capture-modal ref="capture"></capture-modal> -->
        <space-list-modal
        ref="spaceList"
        ></space-list-modal>
      </div>
  </common-template>
</template>

<script>
// import captureModal from './captureModal'
import { mapGetters } from 'vuex'
import searchHelper from '../../mixin/search-helper'
import spaceListModal from './spaceListModal'
export default {
  mixins: [searchHelper],
  data() {
    return {
      list: [],
      search: {
        code: '',
        name: '',
      },
      form: {
        id: [],
      },
      load: false,
      master: null,
      products: null,
      pageTitle: '在庫情報一覧',
    }
  },
  components: {
    // captureModal,
    spaceListModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(err)
      this.$toasted.show('Userの取得でエラー')
    }
    await this.getMaster()
    await this.searchMet()
  },
  methods: {
    async getMaster() {
      try {
        const masterData = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        if (masterData) this.master = masterData.data
        this.products = this.master.products
      } catch (err) {
        // this.$toasted.show(err)
        this.$toasted.show('一覧の取得でエラー')
      }
      this.load = false
    },
    async searchMet() {
      try {
        if (this.list.length) this.checkProductAll(false)
        this.load = true
        this.list = []
        let params = {}
        for (let key of Object.keys(this.search)) {
          if (this.search[key]) params[key] = this.search[key]
        }
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/inventories`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: params,
          }
        )
        this.list = res.data.map((item) => {
          const products = this.products.filter(product => product.id === item.productId)
          if (products.length) {
            item.code = products[0].code
            item.name = products[0].name
          }
          return item
        })
      } catch (err) {
        console.log(err)
        // this.$toasted.show(err)
        this.$toasted.show('一覧の取得でエラー')
      }
      this.load = false
    //   this.checkProductAll(false)
    },
    // 検索結果の製品ごとにクリックするとcheckboxがDOM的に入れ替わる処理
    checkProductItem(item, index) {
      const checked = document.getElementById(`product-${index}`)
      const checkedAll = document.getElementById('product-all')
      const displayList = (Number(this.mixinParPage) > this.list.length) ? this.list.length : Number(this.mixinParPage)
      checked.checked = !checked.checked
      if (!checked.checked) {
        this.form.id = this.form.id.filter(id => id !== item.id)
      } else {
        this.form.id.push(item.id)
      }
      let active = 0
      for (let i = 0; i < displayList; i++) {
        const checked = document.getElementById(`product-${i}`)
        if (checked.checked) active++
      }
      checkedAll.checked = (active === displayList) ? true : false
    },
    // 全ての製品のcheckboxがDOM的に入れ替わる処理
    checkProductAll(status = true) {
      const checkedAll = document.getElementById('product-all')
      if (!this.list.length) return
      if (!status) checkedAll.checked = false
      const displayList = (Number(this.mixinParPage) > this.list.length) ? this.list.length : Number(this.mixinParPage)
      this.form.id = []
      if (checkedAll.checked && status) {
        for (let i = 0; i < displayList; i++) {
          const checked = document.getElementById(`product-${i}`)
          checked.checked = true
          this.form.id.push(Number(checked.value))
        }
      } else {
        for (let i = 0; i < displayList; i++) {
          const checked = document.getElementById(`product-${i}`)
          checked.checked = false
        }
      }
    },
    // 登録画面に遷移
    locationCreate() {
      window.location = '/product/create.html'
    },
    // 製品データ取込のモーダルを開いたときの処理
    captureModalOpen() {
      this.$refs.capture.modalOpen()
    },
    // 一括削除
    async batchDeleteAlert() {
      const confirm = await this.$swal({
        text: this.$t('一括削除確認メッセージ'),
        icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
      })
      if (confirm) {
        try {
          await this.form.id.map(item => {

            this.$axios.put(
              `${this.$appConfig.CommonApiUrl}/partner`,
              { id: item, isDelete: true },
              {
                headers: {
                  Authorization: this.authorization ? this.authorization : null,
                },
              }
            )
          })
          this.$swal.close()
          this.$swal(this.$t('一括データ削除完了メッセージ'), {
            icon: 'success',
            timer: 2000,
          })
        } catch (err) {
          // this.$toasted.show(err)
          this.$toasted.show('削除に失敗しました')
        }
      }
    },
    // 削除処理
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {

          await this.$axios.put(
            `${this.$appConfig.CommonApiUrl}/partner`,
            { id: item.id, isDelete: true },
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$swal(this.$t('データ削除完了メッセージ'), {
            icon: 'success',
            timer: 2000,
          })
        } catch (err) {
          this.$toasted.show(err)
          this.$toasted.show('削除に失敗しました')
        }
      }
    },
    detailLink(item) {
      // console.log(this)
      let params = {}
      params.id = item.id
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/product/detail.html?${this.mixinGetUrlParams(params)}` : `/product/detail.html?${this.mixinGetUrlParams(params)}`
    },
    spaceListModalOpen() {
      window.location = '/space'
      // this.$refs.spaceList.modalOpen()
    },
    inventoryKindListModalOpen() {
      // this.$refs.inventoryKindList.modalOpen()
      window.location = '/inventory-kind'
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped></style>
